import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'

export default class UseriList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            strSearchString:'',
            elementeAfisate:[]
            
        } 
    }



    componentDidMount(){
       this.setState({ elementeAfisate:this.props.elemente || []})
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        if(tx !== null){

            return tx.substring(0,1).toUpperCase()
        }
    }

    filterFunc = (ev) => {

        this.setState({strSearchString:ev.target.value})
        let e = [...this.props.elemente]

        e = e.filter(x=>{
            
            if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            return false

        })

        this.setState({elementeAfisate: e})
    }

    render(){
        return (
            <div className='pm-users-list-container'>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{cursor:this.props.dialogDisplay === 1 ? "initial" : 'pointer', position:'relative'}} className='pm-list-container'>
               
                  
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li style={{cursor:'pointer'}} className='pm-list-item-user' key={idx} onClick={()=>{this.props.onElClick(e)}} >
                                   
                                <Grid container style={{justifyContent: this.props.dialogDisplay === 1 ? 'initial' : ''}} className='pm-list-container-avatar'>
                                
                                    <Grid style={{position:'relative'}} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                    <div className='pm-list-borderleft'></div>
                                    <Avatar style={{marginTop:5}} className='pm-avatar'> { this.getLitereAvatar(e[this.props.onlyColumns.nume] + ' ') } </Avatar>
                      
                                    </Grid>

                                    <Grid  item xs={5} sm={5} md={5} lg={5} xl={5}  className='pm-list-item-avatar'>
                                        <span   className='pm-list-item-span'>{e[this.props.onlyColumns.nume]}</span>
                                    </Grid>

                                    <Grid style={{borderRight:'none', cursor:'pointer',  display:this.props.dialogDisplay === 1 ? 'inline-flex' : 'none'}} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                    
                                    <span   className='pm-list-item-span'><i style={{color:'#10aa2ac5'}} className='material-icons'>add</i></span>
                      
                                    </Grid>

                    
                                    
                                   
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


UseriList.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    onElClick:PropTypes.func

}